import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://gbqrehtjdxpoxjoqbngv.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdicXJlaHRqZHhwb3hqb3Fibmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAzOTMxODYsImV4cCI6MjAxNTk2OTE4Nn0.AFWPMqIy6VHTb1Km56VBcXIRpWkeA0KiaOjy5p3m_ak";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
